import router from './router';
import { getCache } from '@/utils/session';
import getPageTitle from '@/utils/getPageTitle';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { message } from 'ant-design-vue';
import store from './store';

// 国际化
import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
message.config({
  maxCount: 1
});
import messages from './lang/index';
// 配置i18n
const i18n = new VueI18n({
  locale: sessionStorage.getItem('locale') || 'zh_CN',
  // 从缓存中获取当前的语言类型
  messages
});
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

router.beforeEach(async (to, from, next) => {
  var _Object$keys;
  NProgress.start();
  let localeResource = sessionStorage.getItem('localeResource') ? JSON.parse(sessionStorage.getItem('localeResource')) : {};
  let hrefId = sessionStorage.getItem('temporaryToken');
  let res = false;
  if (!((_Object$keys = Object.keys(localeResource)) !== null && _Object$keys !== void 0 && _Object$keys.length)) {
    res = true;
  } else {
    let num = 0;
    for (const key in localeResource) {
      var _Object$keys2;
      const element = localeResource[key];
      if (!((_Object$keys2 = Object.keys(element)) !== null && _Object$keys2 !== void 0 && _Object$keys2.length)) {
        num += 1;
      }
    }
    if (num == 6) {
      res = true;
    }
  }
  if (res && to.path) {
    await store.dispatch('setting/getLocaleResource');
  }
  if (hrefId) {
    await store.dispatch('user/login', {
      way: 3,
      temporaryToken: hrefId
    });
    sessionStorage.removeItem('temporaryToken');
  }
  if (sessionStorage.getItem('locale') == 'zh_CN') {
    document.title = getPageTitle(to.meta.title);
  } else {
    document.title = i18n.tc(to.meta.title) + '-INSURFORCE';
  }
  // console.log(document.title, getPageTitle(to.meta.title));
  const isLogin = getCache('TOKEN');
  if (from.path == '/' && to.path == '/account') {
    next('/login');
  } else if (to.path == '/login' || to.path == '/account') {
    next();
    NProgress.done();
  } else if (from.path == '/' && to.path.indexOf('/previewPage') > -1) {
    // 文章预览
    next();
    NProgress.done();
  } else {
    if (!isLogin) {
      next('/login');
    } else {
      const userInfo = store.state.user.accountInfo;
      if (userInfo) {
        next();
        NProgress.done();
      } else {
        try {
          const {
            nickName
          } = await store.dispatch('user/getInfo');
          const accountRoute = await store.dispatch('permission/getRoute', nickName);
          await store.dispatch('user/getPermissions');
          router.addRoutes(accountRoute);
          next({
            ...to,
            replace: true
          });
          NProgress.done();
        } catch {
          message.error(i18n.tc('获取用户信息失败'));
          next('/login');
          NProgress.done();
        }
      }
    }
  }
});
router.afterEach(() => {
  NProgress.done();
});